module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-row', [_c('b-navbar-nav'), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', {
    staticClass: "page-title mb-2"
  }, [_c('b', [_vm._v(_vm._s(_vm.$route.name))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Assignment"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  }), _vm._v(" "), _c('b-input-group-append', {
    staticClass: "mr-1"
  }, [_c('b-button', {
    attrs: {
      "disabled": !_vm.Filter.commonFilter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [(_vm.OutstandingList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName !== 'Export As Excel',
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('checkJobPendency', 'Export As Excel')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.ExcelBtnName) + "\n                        "), (_vm.ExcelBtnName !== 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('userId')) ? _c('userBasedClient', {
    attrs: {
      "PMC_title": 'User Summary - ' + _vm.$sessionsStorage.get('employeeName'),
      "PMC_USERID": _vm.Filter.userFilter,
      "PMC_USERNAME": _vm.$sessionsStorage.get('nameUser'),
      "PMC_USERDESIG": _vm.$sessionsStorage.get('designation'),
      "PMC_BranchClientPre": _vm.$sessionsStorage.get('branchclientPre'),
      "PMC_TransportTypePre": _vm.$sessionsStorage.get('transportTypePre'),
      "PMC_UserEmpName": _vm.$sessionsStorage.get('employeeName'),
      "PMC_UserEmpCode": _vm.$sessionsStorage.get('employeeCode')
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('h5', [(!_vm.isLoading) ? _c('small', [_vm._v(_vm._s(_vm.OutstandingList.length) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search by ledger name...",
      "size": "sm"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [10, 25, 50, 100],
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-info",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.refreshData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n                        Refresh\n                    ")])], 1)], 1), _vm._v(" "), (_vm.totalItems > _vm.perPage) ? _c('b-pagination', {
    staticClass: "mb-3",
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalItems
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row "
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.columnMain,
      "items": _vm.OutstandingList
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "pending_total",
      fn: function(row0) {
        return [_c('span', {
          staticClass: "mt-1",
          staticStyle: {
            "color": "blue",
            "font-weight": "bold"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.openModal(row0.item, 'lom_all_ids')
            }
          }
        }, [_vm._v(_vm._s(_vm.formatPending(row0.item.pending_total)) + " Rs.")])]
      }
    }, {
      key: "pending_0_30",
      fn: function(row0) {
        return [_c('span', {
          staticClass: "mt-1",
          staticStyle: {
            "color": "blue",
            "font-weight": "bold"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.openModal(row0.item, 'lom_30_ids')
            }
          }
        }, [_vm._v(_vm._s(_vm.formatPending(row0.item.pending_0_30)) + " Rs.")])]
      }
    }, {
      key: "pending_31_60",
      fn: function(row0) {
        return [_c('span', {
          staticClass: "mt-1",
          staticStyle: {
            "color": "blue",
            "font-weight": "bold"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.openModal(row0.item, 'lom_60_ids')
            }
          }
        }, [_vm._v(_vm._s(_vm.formatPending(row0.item.pending_31_60)) + " Rs.")])]
      }
    }, {
      key: "pending_61_90",
      fn: function(row0) {
        return [_c('span', {
          staticClass: "mt-1",
          staticStyle: {
            "color": "blue",
            "font-weight": "bold"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.openModal(row0.item, 'lom_90_ids')
            }
          }
        }, [_vm._v(_vm._s(_vm.formatPending(row0.item.pending_61_90)) + " Rs.")])]
      }
    }, {
      key: "pending_90_plus",
      fn: function(row0) {
        return [_c('span', {
          staticClass: "mt-1",
          staticStyle: {
            "color": "blue",
            "font-weight": "bold"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.openModal(row0.item, 'lom_90Above_ids')
            }
          }
        }, [_vm._v(_vm._s(_vm.formatPending(row0.item.pending_90_plus)) + " Rs.")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2 d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('b-form-select', {
    staticClass: "w-auto",
    attrs: {
      "options": [10, 25, 50, 100],
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-muted"
  }, [_vm._v("per page")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n                    Total Records: " + _vm._s(_vm.totalItems) + "\n                ")])])], 1), _vm._v(" "), _c('b-modal', {
    ref: "ClientBasedOutstandingSummary-modal",
    attrs: {
      "id": "ClientBasedOutstandingSummary-modal",
      "title": 'Client Based Outstanding Summary-' + (_vm.selectedClient ? _vm.selectedClient.clientName : ''),
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.InvoiceColumns,
      "items": _vm.OutstandingInvoiceList,
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter
    },
    on: {
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) *
          _vm.pagination.perPage))])]
      }
    }])
  }), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideSummary
    }
  }, [_vm._v("\n                        Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23ba5df8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ledgerOutstanding/outstandingDash.vue
// module id = 2464
// module chunks = 0